import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { finalize, map } from 'rxjs/operators';
import { BehaviorSubject, Observable } from 'rxjs';
import { ConfigSettingService } from './config-setting.service';
import { Router } from '@angular/router';
import { DataManipService } from './data-manip.service';


function _window(): any {
  // return the global native browser window object
  return window;
}

@Injectable({
  providedIn: 'root'
})
export class CommonService {
  public walletamount = 0;

  public apiErrorDesc: string = "";

  /*private walletSubject: BehaviorSubject<number>;

public get walletamount(): any {
  console.log("Walletget")
    return this.walletSubject.value;
}

public set walletamount(amount) {
  console.log("Walletset",amount)
    this.walletSubject.next(amount)
}*/
  get nativeWindow(): any {
    return _window();
  }

  constructor(private http: HttpClient,  private dataManipSrvc: DataManipService, private configurationsetting: ConfigSettingService, private route: Router) {
    // this.walletamount=0;
  }

  logout() {
    this.route.navigateByUrl("/login");
    this.dataManipSrvc.apiToken = '';
  }

  // getMethod(apiurl) {
  //   return this.http.get(apiurl);
  // }


  getMethod(apiurl) {
    const url = "assets/sample.json"

    return this.http.get(apiurl).pipe(map((res) => {
      this.apiErrorDesc = res['errorDescription'];
      if (this.apiErrorDesc == 'Invalid token.') this.logout();
      return res;
    }), finalize(() => {
      // console.log('[finalize] Called')
    }));
  }

  // getWithParams(apiurl, params) {
  //   let httpparams = new HttpParams();
  //   httpparams = httpparams.append("criteria", JSON.stringify(params));
  //   return this.http.get(apiurl, { params: httpparams });
  // }

  getWithParams(apiurl, params) {
    let httpparams = new HttpParams();
    httpparams = httpparams.append("criteria", JSON.stringify(params));
    // console.log("httpparams", httpparams);
    
    return this.http.get(apiurl, { params: httpparams }).pipe(map((res) => {
      this.apiErrorDesc = res['errorDescription'];
      if (this.apiErrorDesc == 'Invalid token.') this.logout();
      return res;
    })
      , finalize(() => {
        // console.log('[finalize] Called')
      }));
  }

  // postMethod(apiurl, body) {
  //   return this.http.post(apiurl, body);
  // }

  postMethod(apiurl, body, isBaseUrlGiven = false,headers={}) {
    let param: any = {}

    if (isBaseUrlGiven)
      apiurl = this.configurationsetting.getBaseUrl() + apiurl;

    let httpparams = new HttpParams();

    if ((body && typeof body != "object") || (typeof body == "object" && Object.keys(body).length)) {

      if (typeof body == "object" && !body['criteria']) {
        param.criteria = body;
        httpparams = httpparams.append("criteria", body);
      }
      else {
        param.criteria = body['criteria'];
        httpparams = httpparams.append("criteria", body['criteria']);
      }
    }

    // console.log(body);


    return this.http.post(apiurl, param,{'headers':headers}).pipe(map((res) => {
      this.apiErrorDesc = res['errorDescription'];
      if (this.apiErrorDesc == 'Invalid token.') this.logout();

      return res;
    }), finalize(() => {
      // console.log('[finalize] Called')
    }));
  }

  downloadReport(ApiUrl, params) {
    // Create url    
    let httpparams = new HttpParams();
    httpparams = httpparams.append("criteria", JSON.stringify(params));
    return this.http.get(ApiUrl, {
      params: httpparams,
      responseType: "blob",
      headers: new HttpHeaders().append("Content-Type", "application/json")
    });
  }
}
